<template>
  <section class="scg">
    <form class="scg__card" @submit.prevent="onSubmit">
      <p class="scg__eyebrow">HAMWOORI / SERVICE AGREEMENT</p>
      <h1 class="scg__title">계약서 보관함</h1>
      <p class="scg__lead">비밀번호를 입력하면 저장된 계약서 목록이 열립니다.</p>
      <label class="scg__label" for="scg-password">비밀번호</label>
      <input
        id="scg-password"
        ref="inputEl"
        v-model="password"
        class="scg__input"
        type="password"
        inputmode="numeric"
        autocomplete="current-password"
        :disabled="busy"
      />
      <p v-if="error" class="scg__error" role="alert">{{ error }}</p>
      <button type="submit" class="scg__submit" :disabled="busy || !password.trim()">
        {{ busy ? '확인 중…' : '들어가기' }}
      </button>
    </form>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { isContractAuthError, unlockServiceContract } from '@/api/serviceContract'

const emit = defineEmits<{
  unlocked: []
}>()

const password = ref('')
const error = ref('')
const busy = ref(false)
const inputEl = ref<HTMLInputElement | null>(null)

onMounted(() => {
  inputEl.value?.focus()
})

async function onSubmit() {
  if (busy.value) return
  error.value = ''
  busy.value = true
  try {
    await unlockServiceContract(password.value.trim())
    emit('unlocked')
  } catch (e) {
    error.value = isContractAuthError(e) || e instanceof Error
      ? (e instanceof Error ? e.message : '비밀번호가 맞지 않습니다.')
      : '비밀번호가 맞지 않습니다.'
  } finally {
    busy.value = false
  }
}
</script>

<style lang="scss" src="./ContractGate.scss"></style>
